import React from 'react';
import { createPortal } from 'react-dom';

type PortalWrapperProps = {
    portalElement: HTMLDivElement | null;
} & React.PropsWithChildren;

const PortalWrapper: React.FC<PortalWrapperProps> = ({ children, portalElement }) => {
    if (portalElement) {
        return createPortal(children, portalElement);
    }
    return <>{children}</>;
};

export default PortalWrapper;
